import React, { useState } from 'react';
import { FieldProps, FieldValidation } from '@rjsf/core';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
/*
 This is the actual component that will get rendered in the form
*/

type techdocsFolderType = {
  conditional: string;
  tempDir: string;
};

export const TechdocsFolder = ({
  onChange,
  rawErrors,
  formData,
}: FieldProps<string>) => {
  const [formState, setFormState] = useState<techdocsFolderType>({
    conditional: '',
    tempDir: 'techdocsTemp',
  });

  const setFieldState = (key: string, value: string) => {
    let newState;
    if (key === 'conditional' && value === 'no') {
      newState = {
        ...formState,
        [key]: value,
        ['tempDir']: 'techdocsTemp',
      };
    } else if (key === 'conditional' && value === 'yes') {
      newState = {
        ...formState,
        [key]: value,
        ['tempDir']: '',
      };
    } else {
      newState = {
        ...formState,
        [key]: value,
      };
    }

    setFormState(newState);
    onChange(newState);
  };

  const conditionalVar = formState.conditional === 'yes';

  const hideTemplate = () => {
    return <FormControl margin="normal" />;
  };

  const renderTemplate = () => {
    return (
      <>
        <FormControl margin="normal">
          <TextField
            id="tempDir"
            label="Name of temporary Directory"
            variant="standard"
            required={conditionalVar}
            error={rawErrors?.length > 0 && !formData}
            onChange={e => setFieldState('tempDir', e.target.value)}
            disabled={!conditionalVar}
            value={formState.tempDir || ''}
            helperText="Enter the path of your target subfolder"
          />
        </FormControl>
      </>
    );
  };

  return (
    <FormControl margin="normal">
      <InputLabel id="conditionalFieldLabel">
        Are all of your documentation files in a sub folder?
      </InputLabel>
      <Select
        label="conditionalFieldLabel"
        id="conditionalField"
        value={formState.conditional}
        onChange={e => setFieldState('conditional', String(e.target.value))}
      >
        <MenuItem value="yes">Yes</MenuItem>
        <MenuItem value="no">No</MenuItem>
      </Select>

      {conditionalVar ? renderTemplate() : hideTemplate()}
    </FormControl>
  );
};
